import React, {Fragment} from "react"
import { Link } from "react-router-dom"

const categoryContent = [
    {
        category: "Desarrollo de Software",
        icon: "bi bi-arrow-right-short",
        routerPath: "/project-grid"
    },
    {
        category: "Seguridad Web",
        icon: "bi bi-arrow-right-short",
        routerPath: "/project-grid"
    },
    {
        category: "Diseño UI/UX",
        icon: "bi bi-arrow-right-short",
        routerPath: "/project-grid"
    },
    {
        category: "Desarrollo de Apps",
        icon: "bi bi-arrow-right-short",
        routerPath: "/project-grid"
    },
    {
        category: "Programación",
        icon: "bi bi-arrow-right-short",
        routerPath: "/project-grid"
    },
    {
        category: "Desarrollo Web",
        icon: "bi bi-arrow-right-short",
        routerPath: "/project-grid"
    },
]

const ServiceCategory = () => {
    return (
        <Fragment>
            <ul className="list-none service-widget">
                {categoryContent.map((val, i)=>(
                    <li key={i}>
                        <Link to={val.routerPath}>Desarrollo de Software
                            <span className="f-right"><i className={val.icon}/></span>
                        </Link>
                    </li>
                ))}
            </ul>
        </Fragment>
    )
}

export default ServiceCategory